export default "__VITE_ASSET__01dda14b__"